import apiClient from './apiClient';
import type {
  QueueConfigurationResponse,
  QueueConfigurationDto,
  UpdateRetryConfigRequest,
  UpdateDlqTtlRequest,
  UpdateQueueConfigRequest
} from '../types';

/**
 * Service para gerenciar configuracoes de fila (Retry e DLQ TTL)
 */
export const configurationService = {
  /**
   * Obtem todas as configuracoes de fila
   */
  async getAllConfigurations(): Promise<QueueConfigurationResponse> {
    const response = await apiClient.get<QueueConfigurationResponse>('/configuration/queue');
    return response.data;
  },

  /**
   * Obtem configuracao de um tipo de mensagem especifico
   */
  async getConfiguration(messageType: string): Promise<QueueConfigurationDto> {
    const response = await apiClient.get<QueueConfigurationDto>(
      `/configuration/queue/${encodeURIComponent(messageType)}`
    );
    return response.data;
  },

  /**
   * Atualiza configuracao de retry para um tipo de mensagem
   */
  async updateRetryConfig(request: UpdateRetryConfigRequest): Promise<QueueConfigurationDto> {
    const response = await apiClient.put<QueueConfigurationDto>(
      '/configuration/queue/retry',
      request
    );
    return response.data;
  },

  /**
   * Atualiza configuracao de DLQ TTL para um tipo de mensagem
   */
  async updateDlqTtlConfig(request: UpdateDlqTtlRequest): Promise<QueueConfigurationDto> {
    const response = await apiClient.put<QueueConfigurationDto>(
      '/configuration/queue/dlq-ttl',
      request
    );
    return response.data;
  },

  /**
   * Atualiza configuracao completa (retry + DLQ TTL)
   */
  async updateConfiguration(request: UpdateQueueConfigRequest): Promise<QueueConfigurationDto> {
    const response = await apiClient.put<QueueConfigurationDto>(
      '/configuration/queue',
      request
    );
    return response.data;
  },

  /**
   * Remove configuracao customizada (volta para usar Default)
   */
  async deleteConfiguration(messageType: string): Promise<void> {
    await apiClient.delete(`/configuration/queue/${encodeURIComponent(messageType)}`);
  },

  /**
   * Inicializa configuracoes padrao
   */
  async initializeDefaults(): Promise<void> {
    await apiClient.post('/configuration/queue/initialize');
  },

  /**
   * Lista tipos de mensagem disponiveis
   */
  async getMessageTypes(): Promise<string[]> {
    const response = await apiClient.get<string[]>('/configuration/message-types');
    return response.data;
  }
};
